<template>
  <div id="app">
    <div class="bee-spin bee-spin-spinning" v-if="isLoading">
      <span class="bee-spin-dot bee-spin-dot-spin">
        <i class="bee-spin-dot-item"></i>
        <i class="bee-spin-dot-item"></i>
        <i class="bee-spin-dot-item"></i>
        <i class="bee-spin-dot-item"></i>
      </span>
    </div>
    <!-- 后台功能 -->
    <template v-if="$route.path && $route.path.indexOf('acm') > -1">
      <a-locale-provider :locale="locale">
        <router-view />
      </a-locale-provider>
    </template>
    <!-- 其他功能 -->
    <template v-else>
      <router-view />
    </template>

    <feedback :path="path"></feedback>
    <div
      class="home-btn"
      v-if="
        [
          'data-query',
          'chart-production',
          'comparison-analysis',
          'illegal-spots',
          'certificate-manage'
        ].indexOf(path) !== -1
      "
    >
      <router-link to="/start-page">
        <img src="@/assets/images/home-btn.png" alt="" />
      </router-link>
    </div>
    <loading></loading>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import { savePresentTime, savePlanningTime } from '@/utils/store.js'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

import Feedback from '@/components/feedback'
import Loading from '@/components/loading'
export default {
  components: { Feedback, Loading },
  computed: {
    ...mapState('core', [
      {
        loading: 'loading'
      },
      'um'
    ]),
    isLoading() {
      return this.loading && this.$route.name !== 'Signin'
    }
  },
  data() {
    return {
      locale: zhCN,
      path: ''
    }
  },
  watch: {
    $route(to, from) {
      const path = to.fullPath.split('/')
      console.log('path', path)
      this.path = path[path.length - 1]
    },
    um: {
      immediate: true,
      async handler(val) {
        if (val) {
          await this.getDictionary(val)
          await this.getAreaAction()
        }
      }
    }
  },
  async mounted() {
    this.$store.dispatch('getBreedWay')
    this.$store.dispatch('getBreedType')

    moment.locale('zh-cn', {
      months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
      monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
      weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
      weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
      weekdaysMin: '日_一_二_三_四_五_六'.split('_')
    })
  },
  methods: {
    ...mapActions({
      getDictionary: 'getDictionary',
      getAreaAction: 'getAreaAction'
    }),
    init() {
      savePresentTime()
      savePlanningTime()
    }
  }
}
</script>
<style lang="scss">
html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;

  font-family: 思源黑体, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .ant-calendar-input-wrap {
    height: 40px;
  }

  .home-btn {
    position: absolute;
    top: 15px;
    right: 24px;
    z-index: 800;
    height: 40px;
    width: 40px;
    cursor: pointer;

    img {
      width: 40px;
      height: 40px;
    }
  }
}
</style>
